<app-page-bar></app-page-bar>
<app-page>
  <h2>Operational Tasks</h2>
  <section>
    <div class="filter-bar">
      <mat-button-toggle-group [value]="statusFilter"
                               (change)="updateFilters({ status: $event.value })">
        <mat-button-toggle value="OPEN">Open</mat-button-toggle>
        <mat-button-toggle value="RESOLVED">Resolved</mat-button-toggle>
        <mat-button-toggle value="">All</mat-button-toggle>
      </mat-button-toggle-group>

      <mat-form-field class="category-filter">
        <mat-label>Category</mat-label>
        <mat-select [value]="categoryFilter"
                    (selectionChange)="updateFilters({ category: $event.value })">
          <mat-option *ngFor="let cat of categories" [value]="cat.value">
            {{ cat.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="table-container mat-elevation-z8">
      <mat-table #table [dataSource]="dataSource">

        <ng-container matColumnDef="created_at">
          <mat-header-cell *matHeaderCellDef>Time</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.created_at | date:'short' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="category">
          <mat-header-cell *matHeaderCellDef>Category</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-chip-list>
              <mat-chip [color]="row.status === 'OPEN' ? 'warn' : 'primary'" selected>
                {{ row.category }}
              </mat-chip>
            </mat-chip-list>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="title">
          <mat-header-cell *matHeaderCellDef>Title</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.title }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="reference">
          <mat-header-cell *matHeaderCellDef>Reference</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <a *ngIf="row.context?.invoice_id" [routerLink]="['/invoices', row.context.invoice_id]">
              Invoice {{ row.context.invoice_id }}
            </a>
            <span *ngIf="!row.context?.invoice_id">
              {{ row.reference_type }} #{{ row.reference_id }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="context_info">
          <mat-header-cell *matHeaderCellDef>Details</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <!-- AI: Show context-specific info based on category -->
            <ng-container *ngIf="row.category === 'payment_error' && row.context">
              {{ row.context.amount }} {{ row.context.currency }} &rarr; {{ row.context.receiver_name }}
            </ng-container>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-icon *ngIf="row.status === 'OPEN'" color="warn">error</mat-icon>
            <mat-icon *ngIf="row.status === 'RESOLVED'" color="primary">check_circle</mat-icon>
            {{ row.status }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.status === 'OPEN'">
              <button *ngIf="canRetryPayment(row)"
                      mat-raised-button color="primary"
                      (click)="retryPayment(row, $event)"
                      matTooltip="Retry the payment submission">
                <mat-icon>replay</mat-icon> Retry
              </button>
              <button mat-button
                      (click)="resolveTask(row, $event)"
                      matTooltip="Mark as resolved without action">
                <mat-icon>done</mat-icon> Resolve
              </button>
            </ng-container>
            <button
              mat-icon-button
              (click)="toggleComments(row, $event)"
              [color]="row.comment_count > 0 ? 'primary' : ''"
              [matTooltip]="(row.comment_count || 0) + ' comments. Click to view/add.'">
              <mat-icon [matBadge]="row.comment_count" [matBadgeHidden]="!row.comment_count" matBadgeSize="small" matBadgeColor="accent">comment</mat-icon>
            </button>
            <span *ngIf="row.status === 'RESOLVED'" class="resolved-label">
              Resolved {{ row.resolved_at | date:'short' }}
            </span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columns;"
                 [class.status-open]="row.status === 'OPEN'"
                 [class.status-resolved]="row.status === 'RESOLVED'"
                 [class.expanded]="expandedTaskId === row.id"
                 (click)="toggleComments(row, $event)">
        </mat-row>
      </mat-table>
    </div>

    <!-- AI: Expandable comments panel, shown below the table when a task is selected -->
    <mat-card *ngIf="expandedTaskId" class="comments-panel">
      <mat-card-header>
        <mat-card-title>Comments for Task #{{ expandedTaskId }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="comments.length === 0" class="no-comments">
          No comments yet.
        </div>
        <div *ngFor="let comment of comments" class="comment">
          <div class="comment-header">
            <strong>{{ comment.user_name || 'User #' + comment.user_id }}</strong>
            <span class="comment-date">{{ comment.created_at | date:'short' }}</span>
          </div>
          <div class="comment-content">{{ comment.content }}</div>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <mat-form-field class="comment-input" appearance="outline">
          <mat-label>Add a comment...</mat-label>
          <textarea matInput [(ngModel)]="newCommentText" rows="2"></textarea>
        </mat-form-field>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!newCommentText.trim()"
          (click)="addComment(expandedTaskId)">
          Add Comment
        </button>
      </mat-card-actions>
    </mat-card>
  </section>
</app-page>
